<template>
<v-app theme="dark" style="background-color: #ffffff">
<v-toolbar elevation="0" dense absolute class="mt-10 ml-10 mb-10">
<v-img

				alt="Orixe Logo"

				:src="require('../../assets/Logo_Header_White.svg')"

				width="225"

			/>
</v-toolbar>
<v-main>
<v-container fluid class="fill-height" pa-0>
<v-layout row wrap>
<!-- xs12 and sm12 to make it responsive = 12 columns on mobile and 6 columns from medium to XL layouts -->
<v-flex xs12 sm12 md6 class="bluebg">
<!-- Login form here -->
<v-container fill-height fluid>
<v-row align="center" justify="center">
<v-col class="mb-4 mt-16"
><div class="text-center">
<div class="larger-text">
<h1 class="white--text mx-1">Don't have an account?</h1>
<p class="mx-1">
<b>Contact us to start using our services.</b>
</p>
</div>
<v-btn

											color="orangeButton"

											dark

											x-large

											class="mt-2"

											:href="signup_url"
>

											Contact us now
</v-btn>
</div></v-col
>
</v-row>
</v-container>
</v-flex>
<v-flex xs12 sm12 md6 class="white">
<v-container fill-height fluid>
<v-row align="center" justify="center">
<v-col cols="8">
<!-- Check if verify email error occurred. -->
<div 

										class="text-center mx-5"

										v-if="$store.state.user.errorCode == 'E1316'"
>
<div class="larger-text">
<h1 class="primary--text mx-1">We sent you an email</h1>
<p class="mx-1">
<b>Check your inbox for an email from Orixe containing a link to verify your email. It was sent when you registered your account. If you can't find it, please also check your spam folder.</b>
<br>If you didn't receive an email after 10 minutes, try to re-send it using the button below.
</p>
</div>
<v-btn @click="resendEmailVerification">Re-send verification email</v-btn>
<div class="larger-text mt-8">
<p class="mx-1">
<b>Still didn't get it?</b>
<br>Contact us at <a href="mailto:support@orixe.eu">support@orixe.eu</a>
</p>
</div>
<!-- <v-alert

											type="info"

											class="mb-6"
>

											Verify your email in order to log in. Please check your spam-folder if you didn't receive an email.
</v-alert> -->
</div>
<!-- Check if resend verify email was success. -->
<div 

										class="text-center mx-5"

										v-else-if="$store.state.user.errorCode == 'E1320'"
>
<div class="larger-text">
<h1 class="primary--text mx-1">Email Sent</h1>
<p class="mx-1">
<b>We've re-sent the verification email!</b>
<br>Check your inbox for an email from Orixe containing a link to verify your email. If you can't find it, please also check your spam folder.
</p>
</div>
<v-btn @click="clearLogin">Back to login</v-btn>
<div class="larger-text mt-8">
<p class="mx-1">
<b>Still didn't get it?</b>
<br>Contact us at <a href="mailto:support@orixe.eu">support@orixe.eu</a>
</p>
</div>
<!-- <v-alert

											type="info"

											class="mb-6"
>

											Verify your email in order to log in. Please check your spam-folder if you didn't receive an email.
</v-alert> -->
</div>
<div class="text-center mx-5" v-else>
<h1 class="text-left primary--text mb-4">
<span class="larger-text">Log In</span>
</h1>
<v-form @submit.prevent="login">
<div v-if="$store.getters['user/authStatus'] == 'error'">
<v-alert

													type="error"

													class="mb-6"
>

													{{ $store.state.user.error }}
</v-alert>
</div>
<v-text-field

												label="E-mail"

												v-model="username"

												name="login"

												placeholder="email@example.com"

												outlined

												type="text"

												light

												color="primary"
></v-text-field>
 
											<v-text-field

												id="password"

												label="Password"

												name="password"

												placeholder="Password"

												outlined

												:type="passwordVisible ? 'text' : 'password'"

												v-model="password"

												:append-icon="

													passwordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'

												"

												@click:append="togglePassword"
 
												:error-messages="passwordPasteError"
 
												@paste.native="handlePasswordPaste"

												@copy.native.prevent

												@cut.native.prevent

												light
></v-text-field>
<RecaptchaWidget

												v-if="captchaEnabled"

												ref="recaptcha"

												class="mb-4"

											/>
<div class="text-left primary--text larger-text">
<h4>Need help?</h4>
<p>

													Go to
<a

														:href="kb_url"

														target="_blank"

														class="primary--text"
>our knowledgebase</a
>
</p>
 
												<v-btn

													x-large

													color="primary"

													outlined

													to="/forgot"

													class="mr-2 mt-2"
>Forgot Password ?</v-btn
>
<v-btn

													x-large

													type="submit"

													color="orangeButton"

													dark

													class="mt-2"
>Login</v-btn
>
</div>
 
											<v-card-actions>
<v-spacer></v-spacer>
</v-card-actions>
</v-form>
</div>
</v-col>
</v-row>
</v-container>
</v-flex>
</v-layout>
</v-container>
</v-main>
<test-error />
</v-app>
</template>
<style scoped>

.larger-text {

	font-size: 1.4em;

}

::v-deep .v-text-field input {

	font-size: 1.2em;

	height: 100%;

}

::v-deep .v-text-field label {

	font-size: 1.5em;

}

::v-deep .v-toolbar {

	background-color: transparent !important;

}

.bluebg {

	background: transparent linear-gradient(130deg, #21b8c3 0%, #109ca7 100%) 0%

		0% no-repeat padding-box;

	color: white;

}
</style>
 
<script>

import store from "../../store"

import router from "../../router"

import RecaptchaWidget from "../../components/RecaptchaWidget.vue"

import { isRecaptchaEnabled } from "../../utils/recaptcha"

export default {

	name: "Login",

	components: { RecaptchaWidget },

	data() {

		return {

			username: null,

			password: null,

			passwordPasteError: "",


			kb_url:"/knowledge",

			captchaEnabled: isRecaptchaEnabled(),
 
			signup_url: "https://orixe.se/en#contact",
			passwordVisible: false

		}

	},

	methods: {

		getCaptchaToken() {

			return this.$refs.recaptcha?.getToken?.() || ""

		},

		resetCaptcha() {

			this.$refs.recaptcha?.reset?.()

		},

		handlePasswordPaste(event) {

			event.preventDefault()
 
			this.passwordPasteError =

				"Pasting passwords is disabled. Please type your password."
 
			setTimeout(() => {

				this.passwordPasteError = ""

			}, 3000)

		},

		login: async function() {

			let username = this.username

			let password = this.password

			let loginpromise = store.dispatch("user/login", {

				username,

				password,

				captchaToken: this.getCaptchaToken(),

			})

			let that = this

			loginpromise

				.then(function() {
					if (store.getters["user/isGuest"]) {
						window.location.href = "/guestPortal"
					} else {
						router.push(that.$route.query.redirect || "/")

					}

				})

				.catch(() => this.resetCaptcha())

		},

		resendEmailVerification: async function() {

			let username = this.username

			let password = this.password

			let loginpromise = store.dispatch("user/login", {

				username,

				password,

				resendVerification: true,

				captchaToken: this.getCaptchaToken(),

			})

			let that = this

			loginpromise

				.then(function() {

					router.push(that.$route.query.redirect || "/")

				})

				.catch(() => this.resetCaptcha())

		},

		togglePassword() {

			this.passwordVisible = !this.passwordVisible

		},

		clearLogin() {

			store.dispatch("user/resetError", { root: true })

			this.username = null

			this.password = null

		}

	},

	mounted() {

		this.clearLogin()

	}

}
</script>

 